export class Constants {
  public static readonly TOKEN_STORE: string = 'token';
  public static readonly USER_SETTING: string = 'user-setting';
  public static readonly DISPLAY_ORDER: string = 'user-setting-display';
  public static readonly TENANT_TOKEN_STORE: string = '9cas7-13nd8-das01';
  public static readonly APP_USER_SETTINGS: string = 'app-user-settings';
  public static readonly USER_METRICS: string = 'nxnUZxrjrk7ARqv0UZeCLc';
  public static readonly NARRATIVE_DOWNLOAD: string = 'narrative-download-';
  public static readonly NARRATIVE_DOWNLOAD_LIST: string =
    'narrative-download-list';
  public static readonly AGENCY_SUBSTANCE_ABUSE: string =
    'Substance Abuse and Mental Health Services Adminis';
  public static readonly STRATEGY_NAVIGATION_CONFIRMATION: string =
    'navigation-for-strategy';
  public static readonly NOFO_NAVIGATION_CONFIRMATION: string =
    'navigation-for-nofo';
  public static readonly EXTERNAL_WEB_NAVIGATION_CONFIRMATION: string =
    'navigation-for-external-web';
  public static readonly GRANTS_NAVIGATION_CONFIRMATION: string =
    'navigation-for-grants';
  public static readonly DEFAULT_UID: string = 'ABCabc123';
  public static readonly ISSUERS: string = 'issuer-user';
  public static readonly TENANTS_USER: string = 'tenants-user';
  public static readonly ACCESS_TOKEN_CONFIG: string = 'code';
  public static readonly TEMP_ACCESS_TOKEN: string = '7264bc9vx6e921x91623-23x';
  public static readonly AGENCY_UPLOADED: string = 'AgencyUploaded';
  public static readonly TENANT_API: string = 'tenant';
  public static readonly DATA_SET_API: string = 'common/datasets';
  public static readonly ORGANIZATIONS_FETCH_API: string =
    'common/organizations';
  public static readonly ACCESS_TOKE_VALIDATION_API: string =
    'accounts/AccessToken/';
  public static readonly USER_ORGANI_VALIDATION_API: string =
    'accounts/user/org';
  public static readonly USER_DETAILS_VALIDATION_API: string =
    'accounts/user/details';
  public static readonly CSP_NOUNCE: string = '72c4d160e7dc7e61719fc7aff209f0d2';
  public static readonly CSP_NOUNCE_STORAGE: string = 'a7962bb7e78889a6e5851';
  // public static readonly  CSP_NOUNCE: string =
  //   '83474ce2c4867816a7962bb7e78889a6e58516ca06ad1fc933c3ae89df2d8b3a';

  // public static readonly  ATTACHMENTALLFILETYPES =
  //   '.gif,.ico,.jpg,.jpeg,.png,.docx,.doc,.pdf,.dgn,.dwg,.dxf,.odt,.stl,.xml,.psd,.tif,.ppt,.pptx,.xls,.xlsx,.xlsm,.txt,.mp4,.m4v,.m4p,.ogg,.ogv,.avi,.wmv,.mov,.qt,.webm,.mpg,.mp2,.mpeg,.mpe,.mpv,.flv,.swf,.avchd';
  public static readonly ATTACHMENTALLFILETYPES =
    '.jpg,.jpeg,.png,.docx,.doc,.pdf';
  public static readonly GRANT_DOCUEMNTS = '.docx,.doc,.pdf';
  public static readonly GRANT_OTHER_DOCUEMNTS =
    '.docx,.doc,.pdf,.xls,.xlsx,.xlsm,.csv,.png,.jpg,.jpeg';
  public static readonly DATASET_MAIN_FILE = '.xls,.xlsx,.xlsm,.csv';
  public static readonly DATASET_META_FILE =
    '.docx,.doc,.pdf,.txt,.xls,.xlsx,.xlsm,.csv';
}

export enum InsightCustomEvents {
  User_IN = 'UserIn',
  User_OUT = 'UserOut',
  User_Session = 'UserSession',
  Unauthorized = 'Unauthorized',
  OtheEvent = 'OtherEvent',
}

export enum InsightEvents {
  User_Sessions = 'UserSessions',
  User_LoggedIn = 'UserLoggedIn',
  User_Unauthorized = 'UserUnauthorized',
}

export enum AvailableDataSets {
  PublicHealth = 1,
  MentalHealth = 2,
}

export enum VIEW_LEVEL {
  NATIONAL = 1,
  STATE,
  COUNTY,
}

export class InsightMessage {
  public static readonly UserLoggin: any = {
    message: 'User Login Success',
  };
  public static readonly UserLogout: any = {
    message: 'User Logout Success',
  };
}
